import dedent from 'ts-dedent';
import { Provider, WorkflowComponentParamType } from '../types';
import { SelectWorkflowComponent } from './common/selectcomponent';
class Select extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.select',
            group: 'Data Preparation',
            title: 'Select',
            description: `
      This component runs an arbitrary SELECT statement.
      `,
            starred: true
        }, [
            {
                name: 'table',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table',
                optional: true
            },
            {
                name: 'select',
                type: WorkflowComponentParamType.StringSql,
                title: 'SELECT statement',
                placeholder: 'E.g.: *, distance_in_km * 1000 AS distance_in_meters',
                allowExpressions: false
            }
        ]);
        this.supportedProviders = [
            Provider.BigQuery,
            Provider.Postgres,
            Provider.Redshift,
            Provider.Snowflake,
            Provider.DatabricksRest
        ];
    }
    getInnerSql({ params, connection }) {
        let select = params.select ?? '';
        if (select.toUpperCase().startsWith('SELECT')) {
            select = select.substring('SELECT'.length).trim();
        }
        if (connection.type === Provider.DatabricksRest) {
            return dedent `SELECT /*+ REPARTITION(40) */ ${select}
      ${params.table
                ? `FROM ${connection.quoteName(params.table)}`
                : ''}`;
        }
        else {
            return dedent `SELECT ${select}
      ${params.table
                ? `FROM ${connection.quoteName(params.table)}`
                : ''}`;
        }
    }
}
export { Select };
